export function setSelectedCabin (cabinName) {
  return {type: 'SET_SELECTED_CABIN', payload: cabinName}
}

export function setAdultCount (count) {
  return {type: 'SET_ADULT_COUNT', payload: count}
}

export function setSeniorCount (count) {
  return {type: 'SET_SENIOR_COUNT', payload: count}
}

export function setChildCount (count) {
  return {type: 'SET_CHILD_COUNT', payload: count}
}

export function setInfantInLapCount (count) {
  return {type: 'SET_INFANT_IN_LAP_COUNT', payload: count}
}

export function setInfantInSeatCount (count) {
  return {type: 'SET_INFANT_IN_SEAT_COUNT', payload: count}
}



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/PassengerCabinField/actions.js